import { TextInput } from "@mantine/core";
import { useForm } from "@mantine/hooks";
import React from "react";
import { Answer, QuestionQuestionSelect } from "../type";

const QuestionSelectTextQ1: React.VFC<{
    questionSelects: QuestionQuestionSelect[];
    currentQuestionNo: number;
    dispatch: Function;
    lastAnswers: Answer[];
}> = (props) => {
    const lastAnswerName =
        !!props.lastAnswers && props.lastAnswers.length > 0
            ? `${props.lastAnswers[0].answer}`
            : "";

    const form = useForm({
        initialValues: {
            name: lastAnswerName,
        },

        validationRules: {
            //@ts-ignore
            name: (value) => /^.+$/.test(value),
        },
    });

    // form.setFieldValue(
    //     "name",
    //     props.lastAnswers.length > 0 ? `${props.lastAnswers[0].answer}` : ""
    // );

    const handleAnswer = ({ name }) => {
        const nextQuestionNo = props.questionSelects[0].next_question_no;

        props.dispatch({
            type: "ANSWER",
            nextQuestionNo,
            questionNo: props.currentQuestionNo,
            answer: name,
            question_select: props.questionSelects[0],
        });
    };

    return (
        <form
            className="mt-10 md:max-w-sm md:mx-auto"
            //@ts-ignore
            onSubmit={form.onSubmit((values) => handleAnswer(values))}
        >
            <TextInput
                className="skrwd-TextInput px-6"
                required
                error={form.errors.name && "お名前を入力してください"}
                value={form.values.name}
                placeholder="お名前"
                onChange={(event) => {
                    form.setFieldValue("name", event.currentTarget.value);
                }}
            />

            <div className="skrwd-Fixed-OKButton-Container">
                <button className="skrwd-OKButton" type="submit">
                    OK
                </button>
            </div>
        </form>
    );
};

export default QuestionSelectTextQ1;
